import React from 'react';
import Carousel, { CarouselItem, SlickCarouselProvider } from "../../context/Slider";
import { heroSliderdata } from '../../helper/Helper';

function HeroSlider() {
  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <SlickCarouselProvider settings={settings}>
      <div className="min-h-50vh">
        <Carousel>
          {heroSliderdata.map((item, index) => {
            return (
              <CarouselItem key={index}>
                <img
                  src={item.img}
                  alt="Hero Slider Img"
                  className="img-fluid min-h-30vh obj-fit-cover"
                />
              </CarouselItem>
            )
          })}
        </Carousel>
      </div>
    </SlickCarouselProvider>
  );
}

export default HeroSlider;
